import firebase from 'firebase/app';
import { db } from '../firebase';

// Yeah... probably not perfect to maintain two counters at two different places.
// But it's way easier to display the count all over the app since there are already listeners and pagination for ideas
// Saving it additionally to the chat doc makes sense to display a count independently from an idea later on (e.g direct chat)
export async function incrementMessageCount(collection, docId) {
    const docRef = db.collection(collection).doc(docId);
    await db.runTransaction(transaction => {
        return transaction.get(docRef)
        .then(doc => {
            if(!doc.exists) throw "chat doc does not exist!"
            const messageCount = doc.data().messageCount;
            transaction.update(docRef, {messageCount: firebase.firestore.FieldValue.increment(1)})
        })
        .catch((error) => {
            console.log('Couldn\'t update message counters.', error);
        })
    })
}